// @flow
export { default } from './OrderOfferTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderOfferTemplate/index.js